import ManagementQueueControllerPaged from "./controller/ManagementQueueControllerPaged";

export default ManagementQueueControllerPaged;
